import React, { useEffect } from 'react';

const CreateTaskModal = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: CreateTaskModal is not implemented yet.');
  }, []);
  return (
    <>
  { /*CreateTaskModal */} 
 </>
  );
};

export default CreateTaskModal;
